package com.example.crashbit

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import kotlinx.serialization.Serializable
import kotlin.random.Random

@Serializable
data class Wormhole(
    val id: Long = Random.nextLong(),
    @Serializable(with = OffsetSerializer::class)
    var position: Offset,
    var exitAngle: Float = 0f,
    var linkedId: Long? = null,
    @Serializable(with = ColorSerializer::class)
    val color: Color,
    val radius: Float = 200f
)
